export default __webpack_public_path__ + "static/media/truck-loaded.8194193d.png";